export default __webpack_public_path__ + "images/c21e50fb0783f773fb174f19d301bf27-gift-icon-white.svg";